import { Controller } from "@hotwired/stimulus"

// Prices a line from the product just picked in it: the picker's selection event
// carries what the chosen supplier charges, and this drops it into the cost
// field alongside. Bound to the row container, since rows come and go.
//
// A product with no cost on file — a new item, or one the supplier has never
// quoted — leaves the field as it stands rather than zeroing it.
export default class extends Controller {
  static values = { field: { type: String, default: "unit_cost" } }

  fill(event) {
    const cost = event.detail?.cost_price
    if (cost === null || cost === undefined) return

    const row = event.target.closest("tr")
    const input = row?.querySelector(`input[name$="[${this.fieldValue}]"]`)
    if (input) input.value = cost
  }
}
